import { render, staticRenderFns } from "./ClassDetailDialog.vue?vue&type=template&id=38139374"
import script from "./ClassDetailDialog.vue?vue&type=script&lang=js"
export * from "./ClassDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ClassDetailDialog.vue?vue&type=style&index=0&id=38139374&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports